import React, { useMemo, useState, useEffect } from 'react';
import SearchDropdown from '../../atoms/searchdropdown/view';
import { UnitsOfMeasure } from '../../../domain/UnitOfMeasure/model';
import './style.css';

/**
 * UnitSearchDropdown - Searchable selector for units of measure.
 * Shows the selected value as a removable chip.
 *
 * @param {string}   selected   - Current selected unit key (e.g. "70").
 * @param {Function} onSelected - Callback with the selected unit key string.
 */
const UnitSearchDropdown = ({ selected, onSelected }) => {
    const [showSearch, setShowSearch] = useState(!selected);

    // When 'selected' prop changes externally (e.g. edit mode load), sync visibility
    useEffect(() => {
        setShowSearch(!selected);
    }, [selected]);

    const options = useMemo(() =>
        Object.entries(UnitsOfMeasure).map(([key, label]) => ({
            key,
            name: label,
        })),
        []
    );

    const selectedLabel = selected ? UnitsOfMeasure[selected] : null;

    const handleSelect = (option) => {
        if (onSelected) onSelected(option.key);
        setShowSearch(false);
    };

    const handleRemove = () => {
        if (onSelected) onSelected('');
        setShowSearch(true);
    };

    if (!showSearch && selectedLabel) {
        return (
            <div className="unit-chip-wrapper">
                <span className="unit-chip">
                    <span className="unit-chip-label">{selectedLabel}</span>
                    <button
                        type="button"
                        className="unit-chip-remove"
                        onClick={handleRemove}
                        aria-label="Quitar unidad"
                        title="Quitar unidad"
                    >
                        ×
                    </button>
                </span>
            </div>
        );
    }

    return (
        <SearchDropdown
            placeholder="Buscar unidad..."
            options={options}
            path="name"
            onSelect={handleSelect}
        />
    );
};

export default UnitSearchDropdown;
